import type { StepMap } from "@/components/onboarding/components/welcome-wizard";
import { clientEnvModule } from "@/modules/client-env";
import {
  ExistingUserMemAgentFirstMessageStep,
  ExistingUserMemAgentIntroStep,
  ExistingUserProactiveTrialStep,
} from "./existing-user-mem-agent-step";
import { MemAgentFirstMessageStep } from "./mem-agent-first-message-step";
import { MemAgentIntroStep } from "./mem-agent-intro-step";
import { MemAgentShortcutStep } from "./mem-agent-shortcut-step";

export const MemAgentStepMap: StepMap = {
  "mem-agent-intro": {
    id: "mem-agent-intro",
    layout: "compact",
    render: props => <MemAgentIntroStep {...props} />,
  },
  "mem-agent-shortcut": {
    id: "mem-agent-shortcut",
    layout: () => (clientEnvModule.isMacOs() ? "compact-media" : "compact"),
    render: props => <MemAgentShortcutStep {...props} />,
  },
  "mem-agent-first-message": {
    id: "mem-agent-first-message",
    layout: "compact",
    render: props => <MemAgentFirstMessageStep {...props} />,
  },
  "existing-user-mem-agent-intro": {
    id: "existing-user-mem-agent-intro",
    layout: "compact",
    render: props => <ExistingUserMemAgentIntroStep {...props} />,
  },
  "existing-user-proactive-trial": {
    id: "existing-user-proactive-trial",
    layout: "wide",
    render: props => <ExistingUserProactiveTrialStep {...props} />,
  },
  "existing-user-mem-agent-first-message": {
    id: "existing-user-mem-agent-first-message",
    layout: () => (clientEnvModule.isMacOs() ? "compact-media" : "compact"),
    render: props => <ExistingUserMemAgentFirstMessageStep {...props} />,
  },
};
